/* eslint-disable */
/**
 * @license
 * Copyright 2011 Dan Vanderkam (danvdk@gmail.com)
 * MIT-licensed (http://opensource.org/licenses/MIT)
 */

/**
 * @fileoverview A wrapper around the Dygraph class which implements the
 * interface for a GViz (aka Google Visualization API) visualization.
 * It is designed to be a drop-in replacement for Google's AnnotatedTimeline,
 * so the documentation at
 * http://code.google.com/apis/chart/interactive/docs/gallery/annotatedtimeline.html
 * translates over directly.
 *
 * For a full demo, see:
 * - http://dygraphs.com/tests/gviz.html
 * - http://dygraphs.com/tests/annotation-gviz.html
 */

/*global Dygraph:false */
"use strict"

Object.defineProperty(exports, "__esModule", {
	value: true,
})

function _interopRequireDefault(obj) {
	return obj && obj.__esModule ? obj : { default: obj }
}

var _dygraph = require("./dygraph")

var _dygraph2 = _interopRequireDefault(_dygraph)

/**
 * A wrapper around Dygraph that implements the gviz API.
 * @param {!HTMLDivElement} container The DOM object the visualization should
 *     live in.
 * @constructor
 */
var GVizChart = function GVizChart(container) {
	this.container = container
}

/**
 * @param {GVizDataTable} data
 * @param {Object.<*>} options
 */
GVizChart.prototype.draw = function (data, options) {
	// Clear out any existing dygraph.
	// TODO(danvk): would it make more sense to simply redraw using the current
	// date_graph object?
	this.container.innerHTML = ""
	if (typeof this.date_graph != "undefined") {
		this.date_graph.destroy()
	}

	this.date_graph = new _dygraph2["default"](this.container, data, options)
}

/**
 * Google charts compatible setSelection
 * Only row selection is supported, all points in the row will be highlighted
 * @param {Array.<{row:number}>} selection_array array of the selected cells
 * @public
 */
GVizChart.prototype.setSelection = function (selection_array) {
	var row = false
	if (selection_array.length) {
		row = selection_array[0].row
	}
	this.date_graph.setSelection(row)
}

/**
 * Google charts compatible getSelection implementation
 * @return {Array.<{row:number,column:number}>} array of the selected cells
 * @public
 */
GVizChart.prototype.getSelection = function () {
	var selection = []

	var row = this.date_graph.getSelection()

	if (row < 0) return selection

	var points = this.date_graph.layout_.points
	for (var setIdx = 0; setIdx < points.length; ++setIdx) {
		selection.push({ row: row, column: setIdx + 1 })
	}

	return selection
}

exports["default"] = GVizChart
module.exports = exports["default"]
